import { FindSeikyuInfo } from "./commands/FindSeikyuInfo";
import { ApiBase } from "~/extensions/api";
export class SeikyuInfoApi extends ApiBase {
    find(orgNyukyokeiyakuNo) {
        let command = new FindSeikyuInfo(orgNyukyokeiyakuNo);
        return this.request(command);
    }
}
